var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.name)?_c('svg',{staticClass:"Icon",style:(_vm.iconStyle),attrs:{"aria-hidden":"true"},on:{"click":function($event){return _vm.Click()}}},[_c('use',{attrs:{"xlink:href":_vm.iconName}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }